import notFound from '../not-found';
import { resolve } from './urls';

async function action(args) {
  const route = await resolve(args);

  if (!route) {
    return notFound(args);
  }

  if (!route.routeView) {
    return notFound(args);
  }

  const { routeView, options } = route;
  return routeView(options);
}

export default action;
